// extracted by mini-css-extract-plugin
export default {"tile_container":"v7","tile_img_container":"w7","not_recommended_label":"x7","modal_root":"y7","content":"z7","warning":"A7","x_mark":"B7","tile_img":"C7","tile_type":"E7","tile_product_title":"F7","tile_product_price":"G7","tile_descr_line":"H7","tile_descr_icon":"I7","info_icon":"J7","tile_descr_text":"K7","tile_btns_container":"L7","info_container":"M7","info_text":"N7"};
    if(module.hot) {
      // 1715276860231
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  